import { Outlet } from 'react-router';
import { Tabs } from '../ui/Tabs';
import { useTranslation } from '../i18n/I18nProvider';

/**
 * Podnavigacija sekcije. Svaki tab je ruta — klik mijenja URL, ne klasu.
 * Ovo je izravan odgovor na `S.tabKlik` bug iz ARHITEKTURA.md sekcije 1.
 */
interface SectionTab {
  to: string;
  labelKey: string;
  end?: boolean;
}

export function SectionTabs({ items }: { items: readonly SectionTab[] }) {
  const { t } = useTranslation();
  return (
    <>
      <Tabs
        className="mb-6"
        items={items.map((i) => ({ to: i.to, label: t(i.labelKey), ...(i.end ? { end: true } : {}) }))}
      />
      <Outlet />
    </>
  );
}
